import DatePicker, {
    registerLocale,
    type DatePickerProps,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { enUS, fr } from "date-fns/locale";
import { APPC, LSC } from "../config";

registerLocale("en", enUS);
registerLocale("fr", fr);

const currentLocale =
    localStorage.getItem(LSC.APP_USER_LOCALE) || APPC.APP_DEFAULT_LOCALE;

export const AppDatePicker = (props: DatePickerProps) => {
    return (
        <>
            <DatePicker
                autoComplete="false"
                calendarStartDay={1}
                locale={currentLocale}
                {...props}
            />
        </>
    );
};
